var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPaginator = function SvgIconPaginator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(-90 13 12)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00913D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.763 1.066l4.13 4.02a1.18 1.18 0 01.022 1.67L6.9 6.77a1.224 1.224 0 01-1.715.008l-4.13-4.02a1.18 1.18 0 01-.007-1.684 1.224 1.224 0 011.715-.008z",
    transform: "translate(6 8.727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.784 1.067L5.426 5.314a1.181 1.181 0 00-.007 1.685c.474.47 1.237.473 1.714.007l4.358-4.247a1.181 1.181 0 00.021-1.67l-.014-.015a1.223 1.223 0 00-1.714-.007z",
    transform: "translate(6 8.727)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "#00913D",
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPaginator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-paginator.370e10de.svg";
export { ForwardRef as ReactComponent };